/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import BaseImage from 'base-ui/dist/Image';
import { useAmp } from 'next/amp';
import isNumber from 'utils/isNumber';

import useDeviceScreen from 'root/hooks/useDeviceScreen';
import useAbsImageUrl from './useAbsImageUrl';
import getResponsiveImageUrl from './getResponsiveImageUrl';

const Image = ({ src, srcSet, alt, className, style, width, height, lazy, loadingProps }) => {
  const { isMobile } = useDeviceScreen();
  const getAbsImageUrl = useAbsImageUrl();

  if (!src) {
    return null;
  }

  if (typeof src === 'string') {
    const responsiveSrc = getResponsiveImageUrl(src, srcSet, isMobile);
    return (
      <BaseImage
        src={getAbsImageUrl(responsiveSrc)}
        srcSet={(!lazy || useAmp()) && srcSet ? srcSet : null}
        alt={alt}
        className={className}
        style={style}
        width={useAmp() && (width <= 0 || !isNumber(width)) ? '400' : width}
        height={useAmp() && (height <= 0 || !isNumber(width)) ? '300' : height}
        loading="lazy"
        lazy={lazy}
        layout="responsive"
        loadingProps={loadingProps || {
          time: 0,
          width: '100%',
          height: height <= 0 ? '300' : height
        }}
      >
        {lazy && <div style={{ height: `${height}px`, width: '100%', maxWidth: '100%', minWidth: '100%', background: '#edeff4 no-repeat center center' }}></div>}
      </BaseImage>
    );
  }

  // https://snowball.digital/blog/responsive-images-in-react-with-srcset
  const images = Object.keys(src).map((size) => {
    switch (size) {
      case 'big-size_mobile': {
        return `${getAbsImageUrl(src[size])} 425w`;
      }
      case 'medium_large': {
        return `${getAbsImageUrl(src[size])} 768w`;
      }
      case 'large': {
        return `${getAbsImageUrl(src[size])} 1024w`;
      }
      default: {
        return null;
      }
    }
  }).filter(Boolean);
  const responsiveSrc = getResponsiveImageUrl(src.medium_large, images.toString(), isMobile);

  return (
    <BaseImage
      src={responsiveSrc}
      srcSet={!lazy || useAmp() ? images.toString() : null}
      alt={alt}
      className={className}
      width={useAmp() && width <= 0 ? '400' : width}
      height={useAmp() && height <= 0 ? '300' : height}
      style={style}
      loading="lazy"
      lazy={lazy}
      layout="responsive"
      loadingProps={loadingProps || {
        time: 0,
        width: width <= 0 ? '400' : width,
        height: height <= 0 ? '300' : height
      }}
    >
      {lazy && <div style={{ height: `${height}px`, width: `${width}px`, maxWidth: '100%', background: '#edeff4 no-repeat center center' }}></div>}
    </BaseImage>
  );
};

Image.defaultProps = {
  width: 618,
  height: 385,
  lazy: false,
  style: { width: '100%' }
};

Image.propTypes = {
  src: PropTypes.any,
  srcSet: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  lazy: PropTypes.bool,
  loadingProps: PropTypes.object,

};

export default Image;
